<template>
  <div class="pb20" id="rootchart" :style="cssVars">
    <div class="main CTABLE">
      <div class="title">
        REITs资产列表

        <div class="downloadBtns">
          <CButtonsDownload
            :dButtonsDownloads="dButtonsDownloads1"
            @fnButtondownload="fnButtonDL" />

          <span style="display: none">
            <download-excel
              id="downloadExcel"
              :data="dMvSnapshotTable"
              :fields="json_fields"
              header="REITs资产列表"
              name="REITs资产列表.xls">
            </download-excel>
          </span>
        </div>
      </div>

      <div>
        <div class="content_choose_area">
          <CCascader
            @CCascader_select_node="fnCCascader_type_r"
            :default="category_cascader_val_chart_type_r"
            :options="category_cascader_type_r"
            :checkStrictly="false"
            :multiple="true"
            :isDelete="false"
            :middle="true"
            :collapsetags="true"
            >选择类别</CCascader
          >
          <CCascader
            style="margin-left: 15px"
            :checkStrictly="false"
            :multiple="true"
            :isDelete="false"
            wide
            placeholder="请选择个股"
            :collapsetags="true"
            @CCascader_select_val="fnSelect_sel_code"
            :options="CODENAMEDATA">
            选择个股
          </CCascader>
          <CCascader
            style="margin-left: 15px"
            @CCascader_select_val="fnSelect_sel_factor"
            :default="sel_factor"
            :options="sel_factor_list"
            :checkStrictly="false"
            :multiple="true"
            :isDelete="false"
            :middle="true"
            :collapsetags="true">
            选择包含指标
          </CCascader>
        </div>

        <div class="content_area">
          <el-table
            class="table1"
            :header-cell-style="styleBindFun"
            :height="OFFSETHEIGHT - 362"
            :data="dMvSnapshotTable"
            style="width: 100%"
            @cell-click="fnClick">
            <el-table-column prop="REITs代码" label="代码" align="center" width="100">
            </el-table-column>
            <el-table-column prop="REITs简称" label="简称" align="left" width="180">
            </el-table-column>
            <el-table-column prop="大类" label="大类" align="left" width="120"> </el-table-column>
            <el-table-column prop="细分" label="板块" align="left" width="120"> </el-table-column>
            <el-table-column prop="资产名字" label="资产名称" align="left" width="180">
            </el-table-column>
            <el-table-column
              :render-header="renderHeader"
              prop="计量总量"
              label="计量总量"
              align="center"
              width="120"
              v-if="sel_factor.includes('计量总量')">
              <template slot-scope="scope">
                <span>{{ addThousandSeparator(scope.row['计量总量']) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="area"
              label="可供租赁面积"
              align="center"
              width="150"
              sortable
              v-if="sel_factor.includes('可租赁面积')">
              <template slot-scope="scope">
                <span>{{ addThousandSeparator(scope.row['area']) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="用地性质"
              label="土地性质"
              align="center"
              width="180"
              v-if="sel_factor.includes('用地性质')">
            </el-table-column>
            <el-table-column
              prop="上市时间"
              label="上市时间"
              align="center"
              width="150"
              sortable
              v-if="sel_factor.includes('上市时间')">
              <template slot-scope="scope">
                <span v-html="handleStr(scope.row['上市时间'])"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="竣工时间"
              label="竣工时间"
              align="center"
              width="150"
              sortable
              v-if="sel_factor.includes('竣工时间')">
              <template slot-scope="scope">
                <span v-html="handleStr(scope.row['竣工时间'])"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="运营到期时间"
              label="到期时间"
              align="center"
              width="150"
              sortable
              v-if="sel_factor.includes('运营到期时间')">
              <template slot-scope="scope">
                <span v-html="handleStr(scope.row['运营到期时间'])"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="国补到期"
              label="国补到期"
              align="center"
              width="150"
              sortable
              v-if="sel_factor.includes('国补到期')">
              <template slot-scope="scope">
                <span v-html="handleStr(scope.row['国补到期'])"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="原始权益人"
              label="原始权益人"
              align="left"
              width="250"
              v-if="sel_factor.includes('原始权益人')">
              <template slot-scope="scope">
                <span v-html="handleStr(scope.row['原始权益人'])"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="运营机构"
              label="运营机构"
              align="left"
              width="250"
              v-if="sel_factor.includes('运营机构')">
              <template slot-scope="scope">
                <span v-html="handleStr(scope.row['运营机构'])"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="项目公司"
              label="项目公司"
              align="left"
              width="250"
              v-if="sel_factor.includes('项目公司')">
              <template slot-scope="scope">
                <span v-html="handleStr(scope.row['项目公司'])"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="上市估值(亿元)"
              label="上市估值(亿元)"
              align="center"
              width="160"
              sortable>
              <template slot-scope="scope">
                <span>{{ scope.row['上市估值(亿元)'].toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="上期估值(亿元)"
              label="上期估值(亿元)"
              align="center"
              width="180"
              sortable>
              <template #header>
                <span
                  >上期估值(亿元)
                  <el-tooltip effect="dark" placement="top">
                    <template #content>
                      <div style="width: 15vw">
                        上期估值：指上一个<span style="color: #5ce8ee"
                          >上市或扩募募集说明书/年报</span
                        >财报期(目前仅年报更新估值)，如估值披露口径只有总和时，按照上一个估值比例拆分；
                      </div>
                    </template>
                    <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
                  </el-tooltip>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row['上期估值(亿元)'].toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="最新估值(亿元)"
              label="最新估值(亿元)"
              align="center"
              width="180"
              sortable>
              <template #header>
                <span
                  >最新估值(亿元)
                  <el-tooltip effect="dark" placement="top">
                    <template #content>
                      <div style="width: 15vw">
                        本期估值：指最新的<span style="color: #5ce8ee">上市或扩募募集说明书/年</span
                        >报财报期(目前仅年报更新估值)，如估值披露口径只有总和时，按照上一个估值比例拆分；
                      </div>
                    </template>
                    <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
                  </el-tooltip>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row['最新估值(亿元)'].toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- <div ref="content_table" class="content_area downloadTable">
          <el-table
            class="table1"
            :header-cell-style="styleBindFun"
            :data="dMvSnapshotTable"
            style="width: 100%">
            <el-table-column prop="REITs代码" label="代码" align="center" width="100">
            </el-table-column>
            <el-table-column prop="REITs简称" label="简称" align="center" width="180">
            </el-table-column>
            <el-table-column prop="大类" label="大类" align="center" width="120"> </el-table-column>
            <el-table-column prop="细分" label="板块" align="center" width="120"> </el-table-column>
            <el-table-column prop="资产名字" label="资产名称" align="center" width="180">
            </el-table-column>
            <el-table-column
              :render-header="renderHeader"
              prop="计量总量"
              label="计量总量"
              align="center"
              width="180"
              v-if="sel_factor.includes('计量总量')">
            </el-table-column>
            <el-table-column
              prop="area"
              label="可供租赁面积"
              align="center"
              width="180"
              sortable
              v-if="sel_factor.includes('可租赁面积')">
            </el-table-column>
            <el-table-column
              prop="用地性质"
              label="土地性质"
              align="center"
              width="180"
              v-if="sel_factor.includes('用地性质')">
            </el-table-column>
            <el-table-column
              prop="上市时间"
              label="上市时间"
              align="center"
              width="180"
              sortable
              v-if="sel_factor.includes('上市时间')">
            </el-table-column>
            <el-table-column
              prop="竣工时间"
              label="竣工时间"
              align="center"
              width="180"
              sortable
              v-if="sel_factor.includes('竣工时间')">
            </el-table-column>
            <el-table-column
              prop="运营到期时间"
              label="到期时间"
              align="center"
              width="180"
              sortable
              v-if="sel_factor.includes('运营到期时间')">
            </el-table-column>
            <el-table-column
              prop="国补到期"
              label="国补到期"
              align="center"
              width="180"
              sortable
              v-if="sel_factor.includes('国补到期')">
            </el-table-column>
            <el-table-column
              prop="原始权益人"
              label="原始权益人"
              align="center"
              width="180"
              v-if="sel_factor.includes('项目公司')">
            </el-table-column>
            <el-table-column
              prop="运营机构"
              label="运营机构"
              align="center"
              width="180"
              v-if="sel_factor.includes('运营机构')">
            </el-table-column>
            <el-table-column
              prop="项目公司"
              label="项目公司"
              align="center"
              width="180"
              v-if="sel_factor.includes('计量总量')">
            </el-table-column>
            <el-table-column
              prop="上市估值(亿元)"
              label="上市估值(亿元)"
              align="center"
              width="180"
              sortable>
              <template slot-scope="scope">
                <span>{{ scope.row['上市估值(亿元)'].toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="上期估值(亿元)"
              label="上期估值(亿元)"
              align="center"
              width="180"
              sortable>
              <template slot-scope="scope">
                <span>{{ scope.row['上期估值(亿元)'].toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="最新估值(亿元)"
              label="最新估值(亿元)"
              align="center"
              width="180"
              sortable>
              <template slot-scope="scope">
                <span>{{ scope.row['最新估值(亿元)'].toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import CSelects from '@/components/Basic/CSelects';
import CSelect from '@/components/Basic/CSelect';
import CCategoryButton from '@/components/Basic/CCategoryButton';
import CButtonsSeparate from '@/components/Basic/CButtons_separate';
import CButtonsDownload from '@/components/Basic/CButtons_download';

import CTimeButtons from '@/components/Basic/CTimeButtons';
import CCascader from '@/components/Basic/CCascader';

import html2canvas from 'html2canvas';

import CDialog from '@/components/Basic/CDialog';

import { fnReturnTableStyle, fnDownloadBgc } from '@/utils/util';

export default {
  data() {
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME'));
    return {
      OFFSETHEIGHT: 0,
      category_cascader_options: JSON.parse(localStorage.getItem('FINALLYCATEGORY')),

      json_fields: {
        代码: 'REITs代码',
        简称: 'REITs简称',
        大类: '大类',
        板块: '细分',
        资产名字: '资产名字',
        计量总量: '计量总量',
        可供租赁面积: '可租赁面积',
        土地性质: '用地性质',
        上市时间: '上市时间',
        竣工时间: '竣工时间',
        运营到期时间: '运营到期时间',
        国补到期: '国补到期',
        原始权益人: '原始权益人',
        运营机构: '运营机构',
        项目公司: '项目公司',
        '上市估值(亿元)': '上市估值(亿元)',
        '上期估值(亿元)': '上期估值(亿元)',
        '最新估值(亿元)': '最新估值(亿元)',
      },

      CODENAMEDATA: [],
      CODENAMEDATA_values: [],
      category_cascader_val_chart_type_r: [
        '产权类',
        '物流仓储',
        '产业园',
        '保障性住房',
        '消费',
        '经营权类',
        '市政生态',
        '能源',
        '收费公路',
        '公募REITs',
      ],
      category_cascader_type_r: REITsNAME,
      /*       category_cascader_type_r: [
        {
          value: '产权类',
          label: '产权类',
          children: [
            {
              value: '物流仓储',
              label: '物流仓储',
            },
            {
              value: '产业园',
              label: '产业园',
            },
            {
              value: '保障性住房',
              label: '保障性住房',
            },
            {
              value: '消费',
              label: '消费',
            },
            {
              value: '数据中心',
              label: '数据中心',
            },
          ],
        },
        {
          value: '经营权类',
          label: '经营权类',
          children: [
            {
              value: '市政生态',
              label: '市政生态',
            },
            {
              value: '能源',
              label: '能源',
            },
            {
              value: '收费公路',
              label: '收费公路',
            },
          ],
        },
        {
          value: '公募REITs',
          label: '公募REITs',
        },
      ], */
      dMvSnapshotTable: [],
      sel_factor: [
        '竣工时间',
        '运营到期时间',
        '国补到期',
        '计量总量',
        '可租赁面积',
        '用地性质',
        '上市时间',
        '原始权益人',
        '项目公司',
        '运营机构',
      ],
      sel_factor_list: [
        {
          value: '竣工时间',
          label: '竣工时间',
        },
        {
          value: '运营到期时间',
          label: '运营到期时间',
        },
        {
          value: '国补到期',
          label: '国补到期',
        },
        {
          value: '计量总量',
          label: '计量总量',
        },
        {
          value: '可租赁面积',
          label: '可租赁面积',
        },
        {
          value: '用地性质',
          label: '用地性质',
        },
        {
          value: '上市时间',
          label: '上市时间',
        },
        {
          value: '原始权益人',
          label: '原始权益人',
        },
        {
          value: '项目公司',
          label: '项目公司',
        },
        {
          value: '运营机构',
          label: '运营机构',
        },
      ],

      dButtonsDownloads1: [
        // {
        //   id: '241009',
        //   name: '下载图片',
        // },
        {
          id: '241009',
          name: '下载表格',
        },
      ],
      sCurrentTheme: this.$store.state.theme == 'dark' ? true : false,
    };
  },
  mounted() {
    window.addEventListener('resize', this.funResize);
    this.fnGetWidth();
    this.fnCodeName();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.funResize);
  },
  methods: {
    fnClick(row, column, cell) {
      let arr = [row['REITs简称'], row['REITs代码']];
      this.$eventBus.$emit('skipPage', arr);
    },
    handleStr(str) {
      var new_str = str.replace('00:00:00', '').replace(/,/g, '<br/>');
      return new_str;
    },
    addThousandSeparator(str) {
      if (!str) {
        return str;
      }
      // 校验输入是否为有效数字字符串（允许逗号、小数点和负号）
      const isValid = /^-?(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?$/.test(str);
      if (!isValid) return str;
      if (typeof str == 'number') {
        str = str + '';
      }
      // 移除原有逗号，避免重复处理
      const cleanedStr = str.replace(/,/g, '');
      const [integerPart, decimalPart] = cleanedStr.split('.');

      // 添加千分位分隔符
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
    },
    fnCodeName() {
      // 获取对比reits
      let REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2'));
      this.CODENAMEDATA = REITsNAME;
    },
    funResize() {
      this.fnGetWidth();
    },
    styleBindFun() {
      let val = this.$store.state.theme == 'dark' ? true : false;
      return fnReturnTableStyle(val);
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1440 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      let OFFSETHEIGHT = element.offsetHeight;
      this.OFFSETHEIGHT = OFFSETHEIGHT;
      return;
    },
    fnButtonDL(val) {
      if (val == '下载图片') {
        this.FnDownload();
      } else {
        document.getElementById('downloadExcel').click();
      }
    },
    FnDownload() {
      let h = this.$refs.content_table.scrollHeight;
      let w = this.$refs.content_table.scrollWidth;
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.content_table, {
        height: h + 20,
        width: w,
        backgroundColor: fnDownloadBgc(this.sCurrentTheme),
        useCORS: true,
        scale: 1,
      }).then((canvas) => {
        let url = canvas.toDataURL('image/png');
        var a = document.createElement('a'); // 生成一个a元素
        var event = new MouseEvent('click'); // 创建一个单击事件
        a.download = 'REITs资产列表'; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      });
    },

    renderHeader(h, { column }) {
      var str = '';
      if (column.label == '计量总量') {
        str = '建筑面积（sqm）/污水处理量(吨/日)/总装机容量(MW)/公路长度（km）';
      }
      return h('span', [
        h('span', column.label),
        h(
          'el-tooltip',
          {
            props: {
              effect: 'dark',
              content: str,
              placement: 'top',
            },
          },
          [
            h('i', {
              class: 'el-icon-question',
              style: 'color:#409eff;margin-left:5px;',
            }),
          ]
        ),
      ]);
    },

    handleClick() {
      this.fnGetMvSnapshotTable();
    },
    fnCCascader_type_r(val) {
      this.category_cascader_val_chart_type_r = val;
      this.fnGetMvSnapshotTable();
    },
    fnSelect_sel_code(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });
      this.CODENAMEDATA_values = val;
      this.fnGetMvSnapshotTable();
    },
    fnSelect_sel_factor(val) {
      this.sel_factor = val;
      this.fnGetMvSnapshotTable();
    },
    async fnGetMvSnapshotTable() {
      let r_type = this.category_cascader_val_chart_type_r.join('&r_type=');
      let code = this.CODENAMEDATA_values.join('&codes=');
      let sel_factor_list = [
        ...this.sel_factor,
        'REITs代码',
        'REITs简称',
        '资产名字',
        '大类',
        '细分',
        '所处省份',
        '所属市',
      ];
      let sel_factor = sel_factor_list.join('&sel_factor=');

      const { data } = await this.$https.get(
        '/api/v2_5/get_all_asset_info?r_type=' +
          r_type +
          '&codes=' +
          code +
          '&sel_factor=' +
          sel_factor
      );

      if (data.code !== 200) return this.$message.error(data.msg);
      this.dMvSnapshotTable = [];
      data.data.forEach((item) => {
        this.dMvSnapshotTable.push({
          ...item,
          area: item.可租赁面积 ? parseInt(item.可租赁面积) : '',
        });
      });
    },
  },
  components: {
    CSelects,
    CSelect,
    CButtonsSeparate,
    CTimeButtons,
    CCascader,
    CCategoryButton,
    CButtonsDownload,
    CDialog,
  },
  computed: {
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
      };
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.styleBindFun();
      this.fnGetTheme();
      fnDownloadBgc();
    },
  },
};
</script>

<style lang="less" scoped>
.pb20 {
  padding-bottom: 20px;
}

.main {
  background-color: var(--charts_bgc);
  padding-top: 15px;
  border-radius: 20px;
  height: 654px;
  height: auto;
  padding-bottom: 20px;
}

.CTABLE {
  height: auto;
}

// 切换按钮  start --------------------------------------------
.chooseArea {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chooseArea .el-button {
  font-size: 14px;
  font-weight: 400;
  height: 36px;
  // margin-left: 10px;
}

.chooseArea .noActive {
  // background-color: var(--Select-bgc);
  // background-color: red;
  // color: var(--Select-color2);
  // border: 0.98px solid rgba(255, 255, 255, 0.2);

  background-color: var(--Btn-bgc2);
  color: var(--stock_area_item_color1);
  border: 1px solid var(--Btn-borderColor);
}

.checkedBtnStyle {
  // background-color: #1573fe !important;
  background-color: var(--primary-color) !important;
  // color: #ffffff !important;
  color: var(--Btn-color) !important;
  // border: 0.98px solid #1573fe !important;
  border: 1px solid var(--primary-color) !important;
}

.chooseArea .el-button:hover {
  background-color: var(--Btn-bgc_hover);
  color: var(--Btn-color2);
  border: 1px solid var(--primary-color) !important;
}

// 切换按钮  end --------------------------------------------

.title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 28px;
  color: var(--chart_title);
  // border-left: 5px solid rgba(21, 115, 254, 1);
  border-left: 5px solid var(--primary-color);
  padding-left: 13px;
  padding-right: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-top: 15px;
}

.main_choose {
  padding-left: 18px;
  margin-top: 25px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  position: relative;
}

.CTimeButtons {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.main_choose_center {
  display: flex;
  justify-content: center;
}

.main_choose span {
  margin-right: 50px;
  display: flex;
  align-items: center;
  color: var(--chart_title);
  font-size: 14px;
}

.btnArea {
  margin-right: 40px;
}

.colorCategory {
  margin-left: 39px;
}

.summary {
  margin-left: 120px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  width: 52px;
  display: flex;
  justify-content: space-between;
}

.average {
  margin-left: 120px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  width: 92px;
  display: flex;
  justify-content: space-between;
}

// .width20{
//   width: 27%;
// }

// .mobility span:nth-child(1){
//   margin-left: 0px ;
// }

.category {
  margin-left: 50px;
}

.content_choose_area {
  display: flex;
  align-items: center;
  padding: 0px 28px;
  margin-top: 20px;
}

.summary_style {
  color: var(--cascader-color);
  font-size: 14px;
  margin-left: 50px;
}

.content_choose_area_item {
  flex: 1;
  position: relative;
  padding-top: 20px;
}

.content_choose_area_item:nth-child(1) {
  margin-right: 20px;
}

.color_pier {
  position: absolute;
  top: 10%;
  right: 2%;
}

.color_pier_tit {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.51px;
  line-height: 20.58px;
  color: rgba(158, 158, 158, 1);
}

.color_pier_main {
  width: 24px;
  height: 350px;
  float: right;
  margin-top: 20px;
  // margin: 20px auto;
  background: linear-gradient(
    to top,
    #f5fbfc,
    #e9f7fa,
    #c4e9e2,
    #99d8c9,
    #7bcbb3,
    #51b78a,
    #248c46,
    #006328
  );
  border-radius: 5px;
}

.roseCard {
  // padding-bottom: 30px !important;
}

.content_area {
  padding: 20px 20px 0px;
}

.CLASSB_STYLE {
  margin-left: 17px;
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: #1d1f25;
  background-color: var(--table_bgc);
  padding-bottom: 70px !important;
}

::v-deep .el-table::before {
  // background-color: #1d1f25;
  background-color: var(--table_bgc);
}

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body-wrapper {
  height: auto !important;
  max-height: 100% !important;
  // padding-bottom: 10px !important;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  border-bottom: 1px solid var(--table_brc);
  height: 60px;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  color: var(--table_color_hover);
  cursor: pointer;
}

// el-table end

.content {
  margin: 0 20px;
  background-color: var(--charts_bgc);
  border: 1px solid var(--charts_brc);
  border-radius: 10px;
  position: relative;
  // margin-top: 30px;
}

.icon-fangda {
  // right: 6% !important;
}

.icon-fangd3 {
  right: 90px !important;
}

// echarts

.info {
  margin-left: 26px;
  margin-bottom: 14px;
}

.info div {
}

.DDL_info {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.51px;
  line-height: 20.58px;
  color: rgba(158, 158, 158, 1);
  padding-bottom: 15px;
  padding-left: 10px;
}

.value_area {
  display: flex;
  align-items: center;
  justify-content: start;
}

.a {
  height: 20px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: rgba(90, 232, 237, 1);
}

.b {
  height: 20px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: rgba(90, 232, 237, 1);
}

.c {
  height: 20px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: rgba(59, 79, 207, 1);
}

.d {
  height: 20px;
  border-radius: 3px;
  margin-right: 10px;
  background-color: rgba(255, 51, 0, 1);
}

// 数据截止日期
.deadline {
  padding-left: 20px;
  padding-bottom: 20px;
}

.deadline2 {
  position: absolute;
  bottom: 0;
  color: #f8b077;

  // left: 20px;
}

.plotly .legend {
  margin-top: -20px; /* 调整图例距离顶部的距离 */
}
</style>
